module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "whats-in-my-book"
    }
  }, [_c('h1', [_vm._v("What’s in My Book?")]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "extra-bits-and-pieces"
    }
  }, [_c('h2', [_vm._v("Extra Bits and Pieces:")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("An up-date on those we met in Aubusson")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("My reflections on this delightful adventure")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("“Aubusson” the poem I wrote whilst there")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Our costs and how to get there")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c183233a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch008.vue
// module id = 84
// module chunks = 0